import { render } from "./notification-filters.vue?vue&type=template&id=c5371ac8&scoped=true"
import script from "./notification-filters.vue?vue&type=script&lang=js"
export * from "./notification-filters.vue?vue&type=script&lang=js"

import "./notification-filters.vue?vue&type=style&index=0&id=c5371ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5371ac8"]])

export default __exports__